import { useTranslation } from 'react-i18next'

export function ErrorScreen({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation()
  return (
    <main className="asf-centered" role="alert">
      <h1>{t('error_title')}</h1>
      <button type="button" onClick={onRetry}>
        {t('retry')}
      </button>
    </main>
  )
}
